<template>
  <v-container class="no-margins">
    <v-container class="no-margins goBackAtTop" v-if="!!filter">
      <v-btn text @click="setFilter(null)">
        <v-icon>$sl-arrow-left</v-icon>{{$t('labels.apprentices')}}
      </v-btn>
    </v-container>
    <h1>{{headerText}}</h1>
    <template v-if="!filter">
      <MessageBox class="my-5"
        type="info"
      >
        <p>{{$t('company.apprentices-mb1')}}</p>
        <p>{{$t('company.apprentices-mb2')}}</p>
        <p>{{$t('company.apprentices-mb3')}}</p>
      </MessageBox>

      <v-btn block class="btn-label action mb-4" @click="setFilter('ALL')">
        <v-icon>$sl-apprentice</v-icon>
          {{$t('labels.apprentices_all_btn')}}
      </v-btn>
      <v-btn block class="btn-label action mb-4" @click="setFilter('BE')">
        <v-icon>$sl-owl</v-icon>
          {{$t('labels.apprentices_be_btn')}}
      </v-btn>
      <v-btn block class="btn-label action" @click="setFilter('QT')">
        <v-icon>$sl-stairs-ascend</v-icon>
          {{$t('labels.apprentices_qt_btn')}}
      </v-btn>
    </template>

    <template v-else>
      <MessageBox class="my-5" v-if="hasDepartments(get($route, 'params.id', ''))">
        {{ $t('labels.departments-authority') }}
        <p>
          <b>{{ departmentsAuthority }}</b>
        </p>
      </MessageBox>
      <CompanyEmployeeListDepartments type="apprentice" :emp="filteredEmployees">
        <template v-slot:employee-list="props">
          <div>
            <template v-for="emp in props.employeeList" >
              <div :key="`apprentice-${emp.id}`" class="mb-12">
                <h6 class="text-uppercase mb-0 pt-2" style="line-height: 18px">
                  {{ getApprenticeFullName(emp.apprentice) }}
                </h6>
                <template v-if="emp.type === 'QualificationTime'">
                  <QualifyingTimeItem 
                    :education="{ ...emp.education, toDate: emp.toDate, apprentice: emp.apprentice }"
                    :instructors="get(emp, 'instructors', [])"
                  />
                </template>
                <template v-else>
                  <BasicEducationTimeItem 
                    :education="getBookData(emp.education)" 
                    :instructors="get(emp, 'instructors', [])"
                    v-if="emp.education.book"
                  />
                </template> 
                <ActionButton type="application" class="mb-4 mt-4" :actionIcon="getShowIcon(emp.type)" @click="showApprentice(emp)">
                  {{$t('labels.show_apprentice')}}
                </ActionButton>
              </div>
            </template> 
          </div>
        </template>
      </CompanyEmployeeListDepartments>
    </template>
  </v-container>
</template>

<script>
import API from "@/services/api";
import uniq from "lodash/uniq";
import {CompanyRoles} from '@/components/mixins'
import CompanyEmployeeListDepartments from "@/components/Company/CompanyEmployeeListDepartments";
import QualifyingTimeItem from '@/components/Common/QualifyingTime/QualifyingTimeItem'
import BasicEducationTimeItem from '@/components/Common/BasicEducation/BasicEducationTimeItem';
import MessageBox from "@/components/Common/MessageBox";
import ActionButton from '@/components/Common/ActionButton'
import get from "lodash/get";
import flatten from "lodash/flatten";

export default {
  name: "CompanyApprenticeList",

  components: { 
    CompanyEmployeeListDepartments,
    QualifyingTimeItem,
    BasicEducationTimeItem,
    MessageBox,
    ActionButton,
  },
  mixins: [CompanyRoles],

  data() {
    return {
      employees: [],
      filter: null,
    };
  },

  created(){
    this.fetchListData()
  },

  computed:{
    filteredEmployees(){
      if(!this.filter || this.filter === 'ALL'){
        return this.employees
      }
      const filterFn = this.filter === 'QT' 
        ? (e) => e.type === 'QualificationTime' 
        : (e) => e.type !== 'QualificationTime';

      return this.employees.filter(filterFn)
    },

    companyId(){
      return this.$route.params.id;
    },

    headerText(){
      switch (this.filter) {
        case 'ALL':
          return this.$t('labels.apprentices_all')
        case 'BE': 
          return this.$t('labels.apprentices_be')
        case 'QT': 
          return this.$t('labels.apprentices_qt')
        default:
          return this.$t('labels.apprentices')
      }
    },

    departmentsAuthority() {
      return uniq(flatten(get(this, 'employees', []).map((employee) => {
        return employee.workplaces
          ?.find(wP => wP?.workplaceaddress.companyId === get(this, 'companyId', -1))
          ?.workplaceaddress?.departmentWorkplaces?.map(dWp => get(dWp, 'department.name', ''))
      }))).join(', ')
    },
  },

  methods: {
    get,
    
    showApprentice(emp){
      this.$router.push({
        name: 'CompanyApprentice',
        params: {
          id: this.$route.params.id,
          employee_id: emp.id,
          isApprentice: emp.apprentice ? true : false,
        },
      });
    },

    getShowIcon(type){
      return type === 'QualificationTime' ? '$sl-stairs-ascend' : '$sl-owl'
    },

    getBookData(education){
      const { book, ...data } = education
      return {...book, education: data};
    },

    setFilter(v){
      this.filter = v;
    },

    getApprenticeFullName(apprentice){
      return `${apprentice.firstName} ${apprentice.lastName}`;
    },

    fetchListData(){
      API.listEmployments(this.companyId, { type: "apprentice" }).then(({data}) => {
        const empArray = [];
        data.forEach(r => {
          if (r.workplaces && r.workplaces.length > 0) {
            r.workplaces.forEach((w) => { empArray.push(r); })
          }
        });
        this.employees = uniq(empArray, "id");
      })
    }
  }
}
</script>